import { genufitMarkPngSrc, type GenufitMarkTone } from './genufitMarkAssets'

type GenufitFitMarkProps = {
  size?: number
  className?: string
  tone?: GenufitMarkTone
}

/** Auth lockup mark — same locked bullseye as sidebar (HIR-84). */
export function GenufitFitMark({ size = 72, className, tone = 'light' }: GenufitFitMarkProps) {
  return (
    <img
      src={genufitMarkPngSrc('auth', tone, size)}
      width={size}
      height={size}
      alt="GenuFit"
      className={className}
      data-testid="genufit-fit-mark"
    />
  )
}
